import React, { useState } from 'react'
import { Button } from '@/components/Button/Button'
import { useQuizStore } from '@/store/useQuizStore'
import { MinusSvgIcon, PlusCountIcon } from './Icons'

export const NumberCounter = ({ data }: { data: any }) => {
  const currentValue = useQuizStore((s) => s.getAnswer(data.name))
  const setSingle = useQuizStore((s) => s.setSingle)
  const [value, setValue] = useState<number>(currentValue ?? data.defaultValue)

  const handleSetValue = (val: number) => {
    setValue(val)
    setSingle(data.name, val.toString())
  }

  return (
    <div className="flex items-center justify-center gap-5 mt-[22vh] pb-16">
      <Button
        className="p-0 bg-[#ECEDEF] w-10 h-10 rounded-full border-0"
        onClick={() => {
          if (value !== data.min) {
            handleSetValue(value - 1)
          }
        }}
      >
        <MinusSvgIcon />
      </Button>
      <div className="text-[96px] tracking-[-1px] leading-[1.1] font-medium min-w-[152px] text-center">
        {value}
      </div>
      <Button
        className="p-0 bg-[#ECEDEF] w-10 h-10 rounded-full border-0"
        onClick={() => {
          if (value !== data.max) {
            handleSetValue(+value + 1)
          }
        }}
      >
        <PlusCountIcon />
      </Button>
    </div>
  )
}
